
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"148.092","height":"110.76"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"5.091","height":"5.333","rx":"2.545","transform":"translate(126.707 11.043)","fill":"#f9487f"}}),_c('path',{attrs:{"d":"M135.89 0h-8.544L12.202.4a12.216 12.216 0 00-12.2 12.2v85.959a12.216 12.216 0 0012.2 12.2l123.689-.4a12.216 12.216 0 0012.2-12.2V12.202A12.216 12.216 0 00135.89 0zM4.88 12.6a7.329 7.329 0 017.321-7.321l115.144-.4h8.544a7.329 7.329 0 017.321 7.321v11.225l-138.33.4zm138.33 85.562a7.329 7.329 0 01-7.321 7.321l-123.689.4a7.329 7.329 0 01-7.321-7.321V28.705l138.33-.4v69.853z","fill":"#eceef2"}}),_c('g',[_c('path',{attrs:{"d":"M89.2 53.176a21.5 21.5 0 00-30.4 30.4 21.5 21.5 0 0030.4-30.4zM74 50.235a18.149 18.149 0 0115.612 8.913H74.428c-.142-.006-.284-.01-.428-.01a9.254 9.254 0 00-8.637 5.959l-5.031-8.635A18.1 18.1 0 0174 50.235zm-5.463 20.309A5.875 5.875 0 0174 62.497c.084 0 .168 0 .252.006h.084a5.879 5.879 0 11-5.472 8.726l.055-.032zm2.251 15.688A18.135 18.135 0 0158.2 59.476l7.318 12.56a9.239 9.239 0 0010.211 5.416zm3.7.278l7.567-13.447-.071-.04a9.221 9.221 0 00-.852-10.516h10.035a18.143 18.143 0 01-16.68 24z","fill":"#e8ebf0"}})])])
          )
        }
      }
    